var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showChangePasswordPage)?_c('ChangePasswordPage'):_vm._e(),(_vm.showContentPage)?_c('ContentPage'):_vm._e(),(_vm.showForgotPasswordPage)?_c('ForgotPasswordPage'):_vm._e(),(_vm.showLoginPage)?_c('LoginPage'):_vm._e(),_c('Loading'),_c('Confirmation'),_c('Toasts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }